<template>
  <div class="footer" v-bind:class="{ 'show-mobile' : $vuetify.breakpoint.smAndDown, 'small-desktop': $parent.$parent.smallDeskTop, 'mini-desktop': $parent.$parent.miniDeskTop }">
    <div class="container">
      <v-row class="footer-upper-box">
        <v-col class="upper-right-box" cols="12" md="5">
          <span class="footer-brand"><img src="../assets/logo_ko.svg" alt="footer-logo" /></span>
          <ul class="social-btns">
            <li class="social-btn"><a class="icon-outer insta" href="https://www.instagram.com/dietfriends.app/" target="_blank"><font-awesome-icon :icon="['fab', 'instagram']"></font-awesome-icon></a></li>
            <li class="social-btn"><a class="icon-outer facebook" href="https://www.facebook.com/dietfriends.official/?ref=py_c" target="_blank"><font-awesome-icon :icon="['fab', 'facebook-f']"></font-awesome-icon></a></li>
            <li class="social-btn"><a class="icon-outer zendesk" href="https://support.dietfriends.kr/hc/ko" target="_blank"><font-awesome-icon :icon="['fas', 'question']"></font-awesome-icon></a></li>
            <li class="social-btn"><a class="icon-outer store" href="https://smartstore.naver.com/dietfriends" target="_blank"><font-awesome-icon :icon="['fas', 'store']"></font-awesome-icon></a></li>
          </ul>
        </v-col>
        <v-col class="upper-left-box" cols="12" md="7">
          <p class="footer-text">
            (주)열정팩토리 서울시 서초구 잠원동 35-3 아람빌딩 2F
          </p>
          <p class="footer-text">
            대표 이정훈 | 사업자등록번호 114-87-18004 | 통신판매업 2020-서울서초-0815
          </p>
          <p class="footer-text">
            고객문의 support@diretfriends.kr | 유선문의 070-7756-1070 (10:00 ~ 19:00)
          </p>
          <p class="copyright">
            2020 © All Rights Reserved
          </p>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
    export default {
        name: "DfFooter"
    }
</script>

<style scoped lang="scss">
  @import '../variables';
  .footer.show-mobile {
    .upper-right-box, .upper-left-box {
      flex: auto !important;
      padding-left: 1.6rem !important;
    }
    .footer-text {
      font-size: 0.8em !important;
      margin-bottom: 0 !important;
    }
    .social-btns {
      padding-left: 0 !important;
    }
    .upper-right-box {
      align-items: flex-start !important;
    }
    .footer-brand {
      margin-bottom: 1rem;
      img {
        height: 20px !important;
      }
    }
  }
  .footer.small-desktop {
    .footer-upper-box {
      align-items: flex-start !important;
    }
    .copyright {
      margin-top: 1rem !important;
    }
    .upper-left-box {
      .footer-text {
        font-size: 0.8em !important;
        margin: 2px 0 !important;
      }
    }
  }
  .footer {
    background: $footerBackgroundColor;
    display: flex;
    flex-direction: column;
    border-top: 1px solid #ececec;

    .container {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
    }

    .footer-upper-box {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      height: 100%;
      width: 100%;

      .upper-left-box {
        flex: 0.6;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;

        .footer-text {
          font-family: $basicFont;
          font-size: 1em;
          margin: 8px 0;
        }
      }

      .upper-right-box {
        flex: 0.4;
        text-align: left;
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: space-evenly;
        align-items: center;

        .footer-brand {
          font-family: $brandFont;
          font-size: 2.2em;
          color: $basicFontColor;
          img {
            height: 30px;
            width: auto;
          }
        }
      }
    }

    .copyright {
      margin-top: 4rem;
    }

    .social-btns {
      display: flex;
      flex-direction: row;
      padding: 0 0 0 1rem;
      justify-content: flex-start;
      align-items: center;

      .social-btn {
        margin-right: 1rem;
        font-size: 2.2em;
        color: $basicFontColor;
        border-radius: 1.1em;
      }
      .social-btn:hover {
        transition: ease-in-out 0.2s;
        .icon-outer {
          background-color: $primaryBlueColor;
        }
      }

      .icon-outer {
        width: 1em;
        border-radius: 0.6em;
        height: 1em;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: $basicFontColor;

        svg {
          color: white;
          font-size: 0.5em;
        }
      }

      .icon-outer.insta {
        svg {
          font-size: 0.7em;
        }
      }
    }
  }
</style>
